<template>
	<div class="affairs-section-wrapper relative">
		<vx-card class="no-scroll-content">
			<div class="affairs-section">
				<div class="affairs-section-header">
					<h1>{{ $t('scheduledTasks') }}</h1>
				</div>
				<div class="affairs-section-body">
					<div class="affairs-left-panel">

						<vs-button
							icon-pack="feather"
							class="add-affair-btn w-full"
							@click="$emit('addTask',{date:new Date()})"
						>{{ $t('addTask') }}</vs-button>

						<vs-custom-button
							color="primary"
							type="border"
							class="filter-button"
							@click="filter = false"
						>{{ $t('all') }}</vs-custom-button>

						<vs-custom-button
							color="primary"
							type="border"
							class="filter-button"
							@click="filter = true"
						>{{ $t('notDone(many)') }}</vs-custom-button>

					</div>
					<div class="affairs-list">
						<div class="filter-status">
							<h5>{{ $t('sort') }}: <b>{{ filter ? $t('notDone(many)') : $t('all') }}</b></h5>
						</div>
						<div class="affairs-right-panel">
							<AffairsList
								:taskList="taskList"
								:filter="filter"
								@editTask="onEditTask($event)"
								@assignToManager="onAssignToManager"
							></AffairsList>
						</div>
					</div>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import VxCard from '@/components/vx-card/VxCard'
import AffairsList from '@/components/affairs/AffairsList'
import VsCustomButton from "@/components/vs-custom-button/VsCustomButton";
import moment from 'moment'

export default {
	name: 'AffairsSection',
	components: {
		VsCustomButton,
		VxCard,
		AffairsList,
	},
	props: {
		taskList: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			filters: [
				{ name: this.$t('all'), value: false },
				{ name: this.$t('notDone(many)'), value: true }
			],
			filter: false,
		}
	},
	methods: {
		onEditTask(e){
			this.$emit('editTask',e)
		},
		onAssignToManager(e){
			this.$emit('assignToManager',e)
		},
	},
	mounted() {
		this.filterValue = this.filters[0];
	}
}
</script>

<style lang="scss" scoped>
.affairs-section-wrapper {
	width: 40%;

	@media screen and (max-width: 1500px) {
		flex: 100% 0 0;
	}

	.vx-card {
		overflow: hidden;
		min-height: 600px;

		::v-deep .vx-card__collapsible-content.vs-con-loading__container {
			height: 100%;
			overflow: hidden;

			.vx-card__body {
				height: 100%;
			}
		}
	}

	.affairs-section {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;

		.affairs-list {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
		}
	}

	.affairs-section-header {
		padding-bottom: 1.5rem;
	}

	.affairs-section-body {
		display: flex;
		height: 100%;
		overflow: hidden;

		.affairs-left-panel {
			flex: 182px 0 1;
			padding-right: 1rem;
			border-right: 1px solid #eee;

			@media screen and (max-width: 580px) {
				flex: 130px 0 1;
			}

			.left-panel-filter {
				margin-top: 1rem;
			}
		}

		.affairs-right-panel {
			flex: 100px 1 1;
			overflow: auto;
		}
	}

	.filter-status {
		margin-left: 10px;
		padding-bottom: 14px
	}

	.filter-button {
		width: 100%;
		margin-top: 13px;
	}

	.add-affair-btn {
		margin-bottom: 13px;
	}
}
</style>
